import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Upload } from 'lucide-react';

interface FileUploadProps {
  onFileSelect: (file: File) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ onFileSelect }) => {
  const [error, setError] = useState<string | null>(null);

  const onDrop = useCallback((acceptedFiles: File[], rejectedFiles: any[]) => {
    if (rejectedFiles.length > 0) {
      setError('PDFファイル以外はアップロードできません');
      return;
    }

    if (acceptedFiles.length > 0) {
      setError(null);
      onFileSelect(acceptedFiles[0]);
    }
  }, [onFileSelect]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf']
    },
    multiple: false
  });

  return (
    <div
      {...getRootProps()}
      className={`h-full flex flex-col items-center justify-center p-8 rounded-lg transition-colors duration-200 ${
        isDragActive ? 'bg-gray-700/50' : 'bg-transparent'
      }`}
    >
      <input {...getInputProps()} />
      <Upload className="w-12 h-12 mb-4 text-gray-400" />
      <p className="text-center text-gray-400">
        {isDragActive ? (
          'ここにドロップしてください'
        ) : (
          <>
            PDFファイルをドラッグ＆ドロップ<br />
            または<br />
            クリックしてファイルを選択
          </>
        )}
      </p>
      {error && (
        <p data-testid="error-message" className="mt-4 text-red-500">
          {error}
        </p>
      )}
    </div>
  );
};

export default FileUpload; 